import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";

import ApiServer from "../ApiServer.js";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import * as libLocation from "../lib/location.ts";
import * as libUrl from "../lib/url.ts";
import "./page_mealplanner.js";
import * as Screen from "../lib/Screen.js";
import * as mealplannerModal from "./mealplannerModal.ts";
import * as recipeModal from "./recipeModal.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";

import Icons from "../svg/Icons.ts"
import {protoExtend} from "../lib/ObjectUtil.js"
import {recipeSyncCache,recipeCategoriesSyncCache} from "./mealplannerApi.ts";
import {familyPickOther} from "../modal/familypicker.js"
import $ from "../$.js";
var 
  currentRecipeId;


function recipeShareMenu(){
  const 
    metaId = this.metaId(),
    menu = [],
    othersFamily = FwDatas.getFamilies().filter(fam=>fam.metaId!==FwDatas.getFamily().metaId);
  if(othersFamily.length===0){
    menu.push({svg:Icons.ic_email,i18nkey:"actions.viaemailmessage",onclick:"mprecipeshare"})
  }else{
    var submenu = [{svg:Icons.ic_email,i18nkey:"actions.viaemailmessage",onclick:"mprecipeshare"}];
    if(othersFamily.length===1){
      submenu.push({svg:Icons.ic_share_other_circle,i18nkey:i18n.get("actions.inacircle",othersFamily[0]),onclick:"recipecopy|"+metaId+'|'+othersFamily[0].metaId})
    }else if(othersFamily.length>1){
      submenu.push({svg:Icons.ic_share_other_circle,i18nkey:"actions.inothercircle",onclick:"recipecopy|"+metaId})
    }  
    menu.push({svg:Icons.ic_export,i18nkey:"actions.share",onclick:'togglemenu',submenu})
  }
  return {menu}
}

actionMenu.register({
  recipeShareMenu,
  recipeMenu(){
    const 
      metaId = this.metaId(),
      recipe = FwDatas.get(metaId),
      menu = [];
      
    if(recipe.rights.canUpdate){
      menu.push({svg:Icons.ic_edit,i18nkey:"actions.edit",onclick:"recipeedit"})
    }
    var mealplannerPermission = FwDatas.getPermission('mealPlannerFlag');
    if(mealplannerPermission!=='KO_HIDE'){
      menu.push({svg:Icons.calendar.ic_plan_recipe,i18nkey:"mp.recipeplan",onclick:mealplannerPermission==='OK'?'recipeplan':'takepremium'})
    }
    menu.push({svg:Icons.ic_list,i18nkey:"mp.addtolist",onclick:'mpadditemtolist'})
    
    if(recipe.moodStarShortcut()){
      menu.push({svg:Icons.ic_remove_from_favorites,i18nkey:"actions.unstar",onclick:'mpunstar'})
    }else{
      menu.push({svg:Icons.ic_add_to_favorites,i18nkey:"actions.star",onclick:'mpstar'})
    }
    
    recipeShareMenu.apply(this).menu.forEach(sharingMenuItem=>{
      menu.push(sharingMenuItem)
    });
    
    
    menu.push({svg:Icons.ic_print,i18nkey:"actions.print",onclick:"print"})
    
    if(recipe.rights.canDelete){
      menu.push({svg:Icons.ic_delete,i18nkey:"actions.delete",onclick:"recipedelete",color:"var(--red)"})
    }
    
    return {menu}
  }
});

Html.register({
  recipecancel(){
    const id = this.metaId();
    if(!id){
      libLocation.goTo('recipebox.php')
      return;
    }
    var params = Object.assign(libLocation.getURLParams(),{
      mode:null,
      id,
      focus:null
    });
    libLocation.goTo(libUrl.addParams('recipebox.php',params),!Screen.isMobileView());
    
  },
  mprecipeshare(){
    function getLinkAndDisplay(metaId){
      ApiServer.mprecipelink(metaId,function(bean){
        import("../modal/dialog_share.mustache").then(function(TPL){
          var recipe = FwDatas.get(metaId);
          modal.openModal(TPL,{title: 'mp.sharerecipetitle',message:'mp.sharerecipetext',link:bean.link,pictureUrl:recipe.thumb});
        })
      })
    }
    
    let metaId = this.metaId();
    getLinkAndDisplay(metaId);
  },
  
  recipeedit(metaId){
    var params = $.extend(libLocation.getURLParams(),{
      mode:"edit",
      id:metaId||this.metaId(),
      //focus:focus?focus:undefined
    });
    libLocation.goTo(libUrl.addParams('recipebox.php',params),!Screen.isMobileView());
  },
  recipeplan(metaId=this.metaId()){
    mealplannerModal.openRecipePlan(metaId)
  },
  recipeputbyid(metaId){
    ApiServer.mprecipeputbyid(metaId,function(r){
      modal.toast({svg:Icons.recipe.ic_confirmation_toast_saved_recipe,iconStyle:'width:60px',text:i18n.getMustache('mp.recipeadded',r)})
      var params = $.extend(libLocation.getURLParams(),{
        id:r.metaId
      });
      libLocation.replaceState(libUrl.addParams('recipebox.php',params));
     
    });
    amplify.publish("recipeNeedRefresh");
  },
  recipedelete(){
    var metaId = this.metaId();
    modal.confirmDelete("mp.deleterecipe",function(){
        currentRecipeId = undefined;
        var recipe = FwDatas.get(metaId)
        recipe.isRecipe = false;
        ApiServer.mprecipeput(recipe);
        
        var params = $.extend(libLocation.getURLParams(),{
          id:null
        });
        libLocation.replaceState(libUrl.addParams('recipebox.php',params));
        amplify.publish("recipeNeedRefresh");
    })
  
  },
  async recipecopy(metaId=this.metaId(),circleId){
    modal.closeModal();
    if(circleId===undefined){
      var family = await familyPickOther('actions.pickfamily')
      if(!family) return;
      circleId = family.metaId;
    }
    var recipe = recipeSyncCache.get(metaId);
    ApiServer.mprecipeput.prepare({scope:circleId})(protoExtend(recipe,{metaId:null}),recipe.medias.map(media=>media.pictureUrl),function(savedRecipe){
      modal.toast({svg:Icons.ic_done,text:'mp.recipeshared'})
    })
      
    
  }
})

function displayRecipe(recipe){
  //TODO sometimes there is no recipe after creation, find why! instead of doing nothing
  if(!recipe) return;

  import("../mealplanner/recipeDetail.mustache").then(function(TPL){
    Html.setHtml($('#recipeDetail'),TPL,recipe).attr('data-fw-meta-id',recipe.metaId);
  });
  
  setTimeout(function(){
    $('.mp-recipe').each((idx,node)=>{
      let n= $(node);
      if(n.metaId()===currentRecipeId){
        n.toggleClass("selected",true);
        try{
          node.scrollIntoViewIfNeeded()
        }catch(e){
          node.scrollIntoView(true)
        }
        
      }else{
        n.toggleClass("selected",false);
      }
     
    })
  },10);
}
function displayEdit(recipe){
  import("../mealplanner/recipeAdd.mustache").then(function(TPL){
    Html.setHtml($('#recipeDetail'),TPL,recipe||{}).attr('data-fw-meta-id',recipe?recipe.metaId:null);
    var 
      fieldToFocus = libLocation.getURLParam("focus"),
      fieldToFocusName = fieldToFocus?"recipe."+fieldToFocus:"recipe.name";
    $($('#recipeDetail form').get(0)[fieldToFocusName]).focus()
  });
}
function displayMainPane(recipes,dishes,recipeCat){
  recipes = recipes.filter(r=>r.isRecipe)
  currentRecipeId = libLocation.getURLParam("id")||(recipes[0]?recipes[0].metaId:undefined);
  var 
    mode = (recipes.length===0 && !currentRecipeId)?'add':libLocation.getURLParam("mode"),
    name = libLocation.getURLParam("name");
  
  if(mode||libLocation.getURLParam("id")){
    $(".pane-main").addClass('open');
  }else{
    $(".pane-main").removeClass('open');
  }
  
  if(mode==='add'){
    displayEdit({name});
  }else if(mode==='edit' && currentRecipeId){
    displayEdit(FwDatas.get(currentRecipeId));
  }else{
    displayRecipe(FwDatas.get(currentRecipeId));
  }
  
}

ApiServer['ui.mprecipeput'] = function(form){
  
  form['recipe.cookTime'].value = (parseInt(form.cookHour.value)||0)*60+(parseInt(form.cookMin.value)||0);
  form['recipe.prepTime'].value = (parseInt(form.prepHour.value)||0)*60+(parseInt(form.prepMin.value)||0);
  form['recipe.serves'].value = parseInt(form['recipe.serves'].value)||0;
  
  ApiServer.mprecipeput.prepare({"recipe.recipeCategoryIdList":"$empty"})(form,function(recipe){
    amplify.publish("recipeNeedRefresh");
    setTimeout(function(){Html.trigger("mpclick",[recipe.metaId])},10);
  });
  
}
  

INR.onPage(INR.URL.RECIPEBOX,function(){
  //can be accessed only by premium users
  if(FwDatas.getPermission('recipeBoxFlag')!=='OK'){
    libLocation.goTo(INR.URL.ENTER_HOME);
    return;
  }
  if(libLocation.getURLParam('add')){
    recipeModal.recipeaddurl(libLocation.getURLParam('add'))
    libLocation.clearParamInHistory()
    
  }
  INR.subscribe("mpclick",function(id){
    let url = libUrl.addParams('?',{recipeview:libLocation.getURLParam("recipeview"),id:id})
    libLocation.goTo(url,!Screen.isMobileView())
  })
  
  var storedRecipes,storedDishes,storedRecipeCategories;
  INR.subscribe("recipeRefreshed",function(recipes,dishes,recipeCategories){
    storedRecipes = recipes;
    storedDishes = dishes;
    storedRecipeCategories = recipeCategories;
    amplify.publish("handleParam");
  })
  
  INR.subscribe("handleParam",function(){
    displayMainPane(storedRecipes,storedDishes,storedRecipeCategories)
  })
  amplify.publish("recipeNeedRefresh");
  
});
